<template>
  <div class="sidebar">
    <b-nav v-if="applications" class="mt-2" pills vertical>
      <b-nav-item v-b-tooltip.hover.right="'Bodygram'" :to="bodygramRoute">
        <img
          :src="`${$assetsBase}images/icons/fapps/bodygram.svg`"
          alt="Bodygram"
        />
      </b-nav-item>

      <b-nav-item v-b-tooltip.hover.right="'Fitness App'" active>
        <img
          :src="`${$assetsBase}images/icons/fapps/fitness.svg`"
          alt="Fitness App"
        />
      </b-nav-item>

      <b-nav-item
        v-if="isRegionalAppLicensed"
        v-b-tooltip.hover.right="'Regional App'"
        :to="regionalRoute"
      >
        <img
          :src="`${$assetsBase}images/icons/fapps/regional.svg`"
          alt="Regional App"
        />
      </b-nav-item>
      <b-nav-item
        v-else
        v-b-tooltip.hover.right="'Regional App'"
        :disabled="isUsingOfflineDesktopApp"
        :style="isUsingOfflineDesktopApp ? '' : 'opacity: 0.35'"
        @click="openModalToRequestInfoAboutRegionalApp"
      >
        <img
          :src="`${$assetsBase}images/icons/fapps/regional.svg`"
          alt="Regional App"
        />
      </b-nav-item>

      <template v-if="isKetoAppExist">
        <!-- KETO -->
        <b-nav-item
          v-if="isKetoAppLicensed"
          v-b-tooltip.hover.right="'Keto App'"
          :disabled="isUsingOfflineDesktopApp"
          :style="!isUsingOfflineDesktopApp ? '' : 'opacity: 0.35'"
          :to="ketoRoute"
        >
          <img
            :src="`${$assetsBase}images/icons/fapps/keto.svg`"
            alt="Keto App"
          />
        </b-nav-item>
      </template>

      <template v-if="isPentaAppExist">
        <!-- PENTA -->
        <b-nav-item
          v-if="isPentaAppLicensed"
          v-b-tooltip.hover.right="'Penta App'"
          :disabled="isUsingOfflineDesktopApp"
          :style="!isUsingOfflineDesktopApp ? '' : 'opacity: 0.35'"
          :to="ketoRoute"
        >
          <img
            :src="`${$assetsBase}images/icons/fapps/penta.svg`"
            alt="Penta App"
          />
        </b-nav-item>
      </template>

      <b-nav-item
        v-if="!isShared"
        v-b-tooltip.hover.right="'SIFA Dieta'"
        :disabled="isUsingOfflineDesktopApp"
        :style="isUsingOfflineDesktopApp ? '' : 'opacity: 0.35'"
        @click="openModalToRequestInfoAboutSifaApp"
      >
        <img
          :src="`${$assetsBase}images/icons/${manageIcon('AKERN 2023')}.png`"
          alt="SIFA Dieta"
        />
      </b-nav-item>
    </b-nav>

    <modal-to-request-info-about-regional-app
      ref="modal-to-request-info-about-regional-app"
    />
    <modal-to-request-info-about-sifa-app
      ref="modal-to-request-info-about-sifa-app"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getIconByFormula } from '~/utils/icons'

import ModalToRequestInfoAboutRegionalApp from '~/components/modals/ModalToRequestInfoAboutRegionalApp'
import ModalToRequestInfoAboutSifaApp from '~/components/modals/ModalToRequestInfoAboutSifaApp'

export default {
  components: {
    ModalToRequestInfoAboutRegionalApp,
    ModalToRequestInfoAboutSifaApp,
  },
  computed: {
    ...mapGetters({
      accessToken: 'user/token',
      applications: 'applications/list',
      isUsingOfflineDesktopApp: 'network/isLocalBackend',
      isShared: 'utils/isShared',
    }),
    isKetoAppsHided() {
      return (
        process.env.platform !== 'web' ||
        process.env.releaseStage === 'production'
      )
    },
    isRegionalAppLicensed() {
      const regionalApp = this.applications.find(
        (app) => app.code === 'REG' || app.code === 'RGN'
      )

      if (regionalApp) {
        return regionalApp.licensed
      }

      return false
    },
    isHBOAppLicensed() {
      const hboApp = this.applications.find((app) => app.code === 'HBO')

      if (hboApp) {
        return hboApp.licensed
      }

      return false
    },
    isKetoAppExist() {
      return this.applications.find((app) => app.code === 'KETA_TMP')
    },
    isPentaAppExist() {
      return this.applications.find((app) => app.code === 'KETP_TMP')
    },
    isKetoAppLicensed() {
      const ketoApp = this.applications.find((app) => app.code === 'KETA_TMP')

      if (ketoApp) {
        return ketoApp.licensed
      }

      return false
    },
    isPentaAppLicensed() {
      const pentaApp = this.applications.find((app) => app.code === 'KETP_TMP')

      if (pentaApp) {
        return pentaApp.licensed
      }

      return false
    },
    bodygramRoute() {
      if (this.$route.name.includes('fitness-')) {
        const currentRouteNameArr = this.$route.name.split('-')
        currentRouteNameArr.splice(0, 1)
        if (currentRouteNameArr.length > 4) {
          currentRouteNameArr.length = 4
          return this.localePath({
            name: currentRouteNameArr.join('-'),
            params: this.$route.params,
          })
        } else {
          return {
            name: currentRouteNameArr.join('-'),
            params: this.$route.params,
          }
        }
      } else {
        return this.localePath({
          name: 'index',
        })
      }
    },
    regionalRoute() {
      if (this.$route.name.includes('fitness-')) {
        const currentRouteNameArr = this.$route.name.split('-')
        currentRouteNameArr.splice(0, 1)
        if (currentRouteNameArr.length > 4) {
          currentRouteNameArr.length = 4
          return this.localePath({
            name: 'regional-' + currentRouteNameArr.join('-'),
            params: this.$route.params,
          })
        } else {
          return {
            name: 'regional-' + currentRouteNameArr.join('-'),
            params: this.$route.params,
          }
        }
      } else {
        return this.localePath({
          name: 'regional',
        })
      }
    },
    ketoRoute() {
      if (this.$route.name.includes('fitness-')) {
        const currentRouteNameArr = this.$route.name.split('-')
        currentRouteNameArr.splice(0, 1)
        if (currentRouteNameArr.length > 4) {
          currentRouteNameArr.length = 4
          return this.localePath({
            name: 'keto-' + currentRouteNameArr.join('-'),
            params: this.$route.params,
          })
        } else {
          return {
            name: 'keto-' + currentRouteNameArr.join('-'),
            params: this.$route.params,
          }
        }
      } else {
        return this.localePath({
          name: 'keto',
        })
      }
    },
  },
  methods: {
    openModalToRequestInfoAboutRegionalApp() {
      this.$refs['modal-to-request-info-about-regional-app'].open()
    },
    openModalToRequestInfoAboutSifaApp() {
      this.$refs['modal-to-request-info-about-sifa-app'].open()
    },
    manageIcon(formula) {
      return getIconByFormula(formula)
    },
  },
}
</script>
